import roadwiseLogoDarkEn from "./roadwise-logo-dark-en.svg";
import roadwiseLogoDarkFr from "./roadwise-logo-dark-fr.svg";
import roadwiseLogoWhiteEn from "./roadwise-logo-white-en.svg";
import roadwiseLogoWhiteFr from "./roadwise-logo-white-fr.svg";

import roadwiseWarrantyLogoDarkEn from "./roadwise-warranty-logo-dark-en.svg";
import roadwiseWarrantyLogoDarkFr from "./roadwise-warranty-logo-dark-fr.svg";

import roadwiseWarrantyLogoLightEn from "./roadwise-warranty-logo-light-en.svg";
import roadwiseWarrantyLogoLightFr from "./roadwise-warranty-logo-light-fr.svg";

import roadwiseFinancingLogoWhiteEn from "./roadwise-financing-logo-white-en.svg";
import roadwiseFinancingLogoWhiteFr from "./roadwise-financing-logo-white-fr.svg";

import roadwiseFinancingLogoDarkFr from "./roadwise-financing-logo-dark-fr.svg";
import roadwiseFinancingLogoDarkEn from "./roadwise-financing-logo-dark-en.svg";

// Generic
export const roadwiseDarkLogo = {
  srcEn: roadwiseLogoDarkEn,
  srcFr: roadwiseLogoDarkFr,
};

export const roadwiseWhiteLogo = {
  srcEn: roadwiseLogoWhiteEn,
  srcFr: roadwiseLogoWhiteFr,
};

// Waranty
export const roadwiseWarrantyWhiteLogo = {
  srcEn: roadwiseWarrantyLogoLightEn,
  srcFr: roadwiseWarrantyLogoLightFr,
};

export const roadwiseWarrantyDarkLogo = {
  srcEn: roadwiseWarrantyLogoDarkEn,
  srcFr: roadwiseWarrantyLogoDarkFr,
};

// Financing
export const roadwiseFinancingWhiteLogo = {
  srcEn: roadwiseFinancingLogoWhiteEn,
  srcFr: roadwiseFinancingLogoWhiteFr,
};

export const roadwiseFinancingDarkLogo = {
  srcEn: roadwiseFinancingLogoDarkEn,
  srcFr: roadwiseFinancingLogoDarkFr,
};
